import {
  Checkbox,
  FormControlLabel,
  IconButton,
  MenuItem,
  Typography,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Clear from "@material-ui/icons/Clear";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import ControlledSelect from "../../../../Components/ControlledSelect";
import Title from "../../../../Components/Title";
import { getWarehouses } from "../../../../Utils/Common";

const notificationFields = [
  {
    field: "outgoingShipments",
    label: "warehouseOutgoingShipments",
  },
  {
    field: "inboundShipments",
    label: "warehouseInboundShipments",
  },
  {
    field: "stockAlerts",
    label: "warehouseStockAlerts",
  },
];

export default function WarehouseSection({
  unedited,
  emaillist,
  setEmailList,
}) {
  unedited = unedited || emaillist;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [warehouses, setWarehouses] = useState([]);
  const [resetKey, setResetKey] = useState("warehouse-select");

  useEffect(() => {
    getWarehouses((items) => setWarehouses(items || []), dispatch);
  }, [dispatch]);

  const getWarehouseLabel = (warehouse) =>
    warehouse?.label || warehouse?.name || warehouse?.value || "";

  const getSubscriptionWarehouseId = (subscription) => subscription?.Warehouse?.id;

  const getCurrentSubscription = (subscription) =>
    emaillist?.EmailListWarehouses?.find(
      (item) =>
        getSubscriptionWarehouseId(item) === getSubscriptionWarehouseId(subscription),
    );

  const updateSubscription = (subscription, field, value) => {
    const warehouseId = getSubscriptionWarehouseId(subscription);
    setEmailList({
      ...emaillist,
      EmailListWarehouses: (emaillist?.EmailListWarehouses || []).map((item) =>
        getSubscriptionWarehouseId(item) === warehouseId
          ? { ...item, [field]: value ? 1 : 0 }
          : item,
      ),
    });
  };

  const removeSubscription = (subscription) => {
    const warehouseId = getSubscriptionWarehouseId(subscription);
    setEmailList({
      ...emaillist,
      EmailListWarehouses: (emaillist?.EmailListWarehouses || []).filter(
        (item) => getSubscriptionWarehouseId(item) !== warehouseId,
      ),
    });
  };

  const renderSubscription = (subscription, index, isAdded) => {
    const current = getCurrentSubscription(subscription);
    if (!subscription?.Warehouse) {
      return null;
    }
    return (
      <MenuItem
        key={getSubscriptionWarehouseId(subscription) || index}
        style={{
          ...(current ? {} : { textDecoration: "line-through" }),
          ...(isAdded ? { backgroundColor: "rgb(177 255 184)" } : {}),
          alignItems: "flex-start",
        }}
      >
        <Grid container direction="column">
          <Grid item>
            <Typography style={{ fontSize: 15 }}>
              {getWarehouseLabel(subscription.Warehouse)}
            </Typography>
          </Grid>
          <Grid item container direction="column">
            {notificationFields.map((item) => (
              <FormControlLabel
                key={item.field}
                control={
                  <Checkbox
                    size="small"
                    color="primary"
                    checked={!!current?.[item.field]}
                    disabled={!current}
                    onChange={(e, value) => {
                      updateSubscription(subscription, item.field, value);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 12 }}>
                    {t("emailLists." + item.label)}
                  </Typography>
                }
              />
            ))}
          </Grid>
        </Grid>
        <IconButton
          style={{ position: "absolute", right: 0 }}
          onClick={() => {
            removeSubscription(subscription);
          }}
        >
          <Clear />
        </IconButton>
      </MenuItem>
    );
  };

  const selectedWarehouseIds = (emaillist?.EmailListWarehouses || []).map(
    (item) => getSubscriptionWarehouseId(item),
  );
  const warehouseOptions = warehouses
    .filter((warehouse) => !selectedWarehouseIds.includes(warehouse.id))
    .map((warehouse) => ({
      ...warehouse,
      value: String(warehouse.id),
      label: getWarehouseLabel(warehouse),
    }));

  return (
    <Grid item sm={3} xs={12}>
      <Title>{t("emailLists.warehouses")}</Title>
      {unedited?.EmailListWarehouses?.map((subscription, index) =>
        renderSubscription(subscription, index),
      )}
      {emaillist?.EmailListWarehouses?.filter(
        (subscription) =>
          !unedited?.EmailListWarehouses?.length ||
          !unedited.EmailListWarehouses.find(
            (item) =>
              getSubscriptionWarehouseId(item) ===
              getSubscriptionWarehouseId(subscription),
          ),
      ).map((subscription, index) =>
        renderSubscription(subscription, index, true),
      )}
      <ControlledSelect
        key={resetKey}
        itemlist={warehouseOptions}
        label={t("emailLists.selectWarehouse")}
        onChange={(event) => {
          const warehouse = warehouses.find(
            (item) => String(item.id) === event.target.value,
          );
          if (!warehouse) {
            return;
          }
          setEmailList({
            ...emaillist,
            EmailListWarehouses: [
              ...(emaillist?.EmailListWarehouses || []),
              {
                Warehouse: warehouse,
                outgoingShipments: 1,
                inboundShipments: 1,
                stockAlerts: 1,
              },
            ],
          });
          setResetKey(new Date().toISOString());
        }}
      />
    </Grid>
  );
}
